
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.194 2.816a7.339 7.339 0 01-6.43 12.421C5.371 15 4.835 13.3 5.828 12.305l1.107-1.107a1.507 1.507 0 000-2.124 1.507 1.507 0 00-2.124 0L3.705 10.18c-.994.994-2.696.456-2.933-.935a7.338 7.338 0 0112.421-6.43zm-.47.47a6.674 6.674 0 00-11.3 5.85 1.067 1.067 0 001.811.575l1.108-1.107a2.174 2.174 0 013.063 0c.843.843.843 2.22 0 3.064L6.3 12.774c-.62.619-.28 1.665.576 1.811a6.674 6.674 0 005.849-11.3z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.094 3.024A1.41 1.41 0 118.1 5.016a1.41 1.41 0 011.994-1.992zm-.47.47a.744.744 0 10-1.053 1.053.744.744 0 001.053-1.053zM12.986 5.916a1.41 1.41 0 11-1.995 1.992 1.41 1.41 0 011.995-1.992zm-.47.47a.744.744 0 10-1.053 1.053.744.744 0 001.053-1.053zM6.159 3.748a1.409 1.409 0 11-1.992 1.993 1.409 1.409 0 011.992-1.993zm-.47.47a.744.744 0 10-1.053 1.053.744.744 0 001.053-1.053zM12.262 9.85a1.409 1.409 0 11-1.992 1.993 1.409 1.409 0 011.992-1.992zm-.47.47a.744.744 0 10-1.053 1.054.744.744 0 001.053-1.053z","fill":"currentColor"}})])
          )
        }
      }
    